//引入vue-i18n组件
import { createI18n } from 'vue-i18n' 
import zh from './zh'  // 中文语言包
import en from './en'  // 英文语言包
import de from './de'  // 德语语言包
import al from './al'  // 阿拉伯语言包
import el from './el'  // 俄语语言包
import fa from './fa'  // 繁体语言包
import ja from './ja'  // 日语语言包
import po from './po'  // 葡萄牙语言包
import tu from './tu'  // 土耳其语言包
import xi from './xi'  // 西班牙语言包
import yi from './yi'  // 意大利语言包
	var lang_type = sessionStorage.getItem("lang_type");
	if(!lang_type){
		lang_type = "en"
	}
// 实例化I18n
const i18n = createI18n({

    locale: lang_type, // 初始化配置语言
    messages: {
        zh,
        en,
		de,
		al,
		el,
		fa,
		ja,
		po,
		tu,
		xi,
		yi
    }
})
export default i18n